import { ISeoMetaData } from '.'

export const eMSNSeoMetaData: ISeoMetaData[] = [
  {
    path: '/eMSN',
    seo: {
      en: {
        title: 'Electronic Medicare Summary Notices (eMSNs) | Medicare',
        description: 'Your eMSN is your official claims statement that shows what Medicare paid for items and services. You can use your eMSN to file an appeal if an item or service is denied. Your eMSNs are stored here for 3 years.'
      },
      es: {
        title: 'Resumen de Medicare electrónico (eMSNs) | Medicare',
        description: 'Su eMSN es su declaración de reclamos oficial que muestra lo que Medicare pagó por los artículos y servicios. Puede utilizar su eMSN para presentar una apelación si se rechaza un artículo o servicio. Sus eMSN se guardan aquí durante 3 años.'
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: 'eMSN'
}))
